import { render, staticRenderFns } from "./CompanyNewsList.vue?vue&type=template&id=413822d0"
import script from "./CompanyNewsList.vue?vue&type=script&lang=js"
export * from "./CompanyNewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports